<template>
	<component :is="'div'">
		<!-- Alert: No item found -->
		<b-alert
			variant="danger"
			:show="userData === undefined"
		>
			<h4 class="alert-heading">Error al obtener los datos del usuario</h4>
			<div class="alert-body">
				No se encontró ningún usuario con este id. Verificar en la
				<b-link
					class="alert-link"
					:to="{ name: 'user-management-list'}"
				>Lista de usuarios</b-link> para buscar otro usuario.
			</div>
		</b-alert>

		<b-tabs
			v-if="userData"
			pills
		>
			<!-- Tab: General Information -->
			<b-tab>
				<template #title>
					<feather-icon
						icon="InfoIcon"
						size="16"
						class="mr-0 mr-sm-50"
					/>
					<span class="d-none d-sm-inline">Información general</span>
				</template>

				<user-management-edit-tab-general
					class="mt-2 pt-75"
					:user-data="userData"
				/>
			</b-tab>
		</b-tabs>
	</component>
</template>

<script>
import UserManagementEditTabGeneral from "./general-information/UserManagementEditTabGeneral.vue"
import userManagementStoreModule from "../userManagementStoreModule"
import useNotifications from "@notifications"
import { ref, onUnmounted } from "@vue/composition-api"
import router from "@/router"
import store from "@/store"

export default {
	components: {
		UserManagementEditTabGeneral
	},
	setup() {
		const { toastNotification } = useNotifications()

		// REFS
		const userData = ref(null)

		const USER_MGMT_STORE_NAME = "app-user-management"

		// REGISTER MODULE
		if (!store.hasModule(USER_MGMT_STORE_NAME))
			store.registerModule(USER_MGMT_STORE_NAME, userManagementStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(USER_MGMT_STORE_NAME))
				store.unregisterModule(USER_MGMT_STORE_NAME)
		})

		store
			.dispatch("app-user-management/fetchUser", { id: router.currentRoute.params.id })
			.then((response) => {
				if (response.data === "error") {
					userData.value = undefined
				} else {
					userData.value = response.data.user
				}
			})
			.catch((error) => {
				if (error.response.status === 404) {
					userData.value = undefined
				}
				toastNotification(error.response.data.message, false)
			})

		return {
			// DATA
			userData
		}
	}
}
</script>
